import { TFunction, i18n as Ii18n } from 'i18next';

export const translateWithFallback = (key: string, fallbackText: string, t: TFunction<'translation', undefined, 'translation'>, i18n: Ii18n) => {
    if (i18n.exists(key)) {
        return t(key);
    }

    return fallbackText;
};
